import { useState, useCallback } from "react"
import { useDynamicElements } from "./useDynamicElements"

export const useAutoSave = organizationId => {
  const { dispatches } = useDynamicElements()
  const [savingRows, setSavingRows] = useState(new Set())
  const [successRows, setSuccessRows] = useState(new Set())

  const startSaving = useCallback(rowId => {
    setSavingRows(prev => new Set([...prev, rowId]))
    setSuccessRows(prev => {
      const newSet = new Set(prev)
      newSet.delete(rowId)
      return newSet
    })
  }, [])

  const stopSaving = useCallback((rowId, success = false) => {
    setSavingRows(prev => {
      const newSet = new Set(prev)
      newSet.delete(rowId)
      return newSet
    })

    if (success) {
      setSuccessRows(prev => new Set([...prev, rowId]))

      setTimeout(() => {
        setSuccessRows(prev => {
          const newSet = new Set(prev)
          newSet.delete(rowId)
          return newSet
        })
      }, 2000)
    }
  }, [])

  const autoSave = useCallback(
    async row => {
      const rowId = row.itemId

      startSaving(rowId)

      try {
        const isSuccess = await dispatches.editElement(row, organizationId)
        stopSaving(rowId, isSuccess)
      } catch (error) {
        stopSaving(rowId, false)
      }
    },
    [dispatches, organizationId, startSaving, stopSaving],
  )

  const isSaving = useCallback(
    rowId => {
      return savingRows.has(rowId)
    },
    [savingRows],
  )

  const isSuccess = useCallback(
    rowId => {
      return successRows.has(rowId)
    },
    [successRows],
  )

  const shouldShowButton = useCallback(
    rowId => {
      return isSaving(rowId) || isSuccess(rowId)
    },
    [isSaving, isSuccess],
  )

  return {
    autoSave,
    isSaving,
    isSuccess,
    shouldShowButton,
  }
}
